import { vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a6ac748")

_pushScopeId("data-v-1a6ac748")
const _hoisted_1 = { class: "switch" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", null, "Animations?")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("label", _hoisted_1, [
    _withDirectives(_createVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.animationToggle = $event)),
      type: "checkbox",
      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitAnimationToggle && _ctx.emitAnimationToggle(...args)))
    }, null, 544), [
      [_vModelCheckbox, _ctx.animationToggle]
    ]),
    _hoisted_2
  ]))
})